<template>
    <div class="now">

        <app-page-title>Am besten bewertet...</app-page-title>

        <app-loader v-if="loading && page === 1"></app-loader>

        <app-card :items = "getMovies"></app-card>

        <v-container v-if="getMovies.pages !== page && getMovies.movies.length !== 0">
            <v-layout row>
                <v-flex>
                    <div class="text-xs-center">
                        <v-btn
                        flat
                        @click="loadMore"
                        :loading="loading">
                            Mehr
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<script>
import PageTitle from '../components/PageTitle'
import MovieCard from '../components/MovieCard'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            category: 'top_rated',
            page: 1
        }
    },
    components: {
        appPageTitle: PageTitle,
        appCard: MovieCard
    },
    methods: {
        loadMore() {
            this.page++;
            this.$store.dispatch('getResults', {category: this.category, page: this.page});
        }
    },
    computed: {
        ...mapState({
            getMovies(state) {
               return state.quickSearch.topRated
            }
        }),
        loading() {
            return this.$store.getters.loading
        }
    },
    created() {

        this.$store.dispatch('getResults', {category: this.category});
    }
}
</script>